"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminManageReferralRequestModes = exports.ManageReferralRequestModes = exports.ReferralStatuses = exports.ReferralRecordTypes = void 0;
var ReferralRecordTypes;
(function (ReferralRecordTypes) {
    ReferralRecordTypes["EARNING"] = "EARNING";
    ReferralRecordTypes["CASH_OUT_REQUEST"] = "CASH_OUT_REQUEST";
})(ReferralRecordTypes || (exports.ReferralRecordTypes = ReferralRecordTypes = {}));
var ReferralStatuses;
(function (ReferralStatuses) {
    ReferralStatuses["REJECTED"] = "REJECTED";
    ReferralStatuses["PROCESSING"] = "PROCESSING";
    ReferralStatuses["SUCCESSFUL"] = "SUCCESSFUL";
})(ReferralStatuses || (exports.ReferralStatuses = ReferralStatuses = {}));
var ManageReferralRequestModes;
(function (ManageReferralRequestModes) {
    ManageReferralRequestModes["INVITE"] = "invite";
    ManageReferralRequestModes["PAYPAL"] = "paypal";
    ManageReferralRequestModes["HISTORY"] = "history";
    ManageReferralRequestModes["CASH_OUT"] = "cash-out";
})(ManageReferralRequestModes || (exports.ManageReferralRequestModes = ManageReferralRequestModes = {}));
var AdminManageReferralRequestModes;
(function (AdminManageReferralRequestModes) {
    AdminManageReferralRequestModes["HISTORY"] = "history";
    AdminManageReferralRequestModes["CASH_OUT"] = "cash-out";
})(AdminManageReferralRequestModes || (exports.AdminManageReferralRequestModes = AdminManageReferralRequestModes = {}));
